import { useNavigate, useLocation } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { pageLinks } from '../../pageLinks'

const tabs = [
  { key: 'home', label: '首页', icon: 'lucide:home', path: pageLinks.Home() },
  { key: 'settings', label: '设置', icon: 'lucide:settings', path: pageLinks.Settings() },
] as const

export function TabBar() {
  const navigate = useNavigate()
  const location = useLocation()

  const activeTab = location.pathname === pageLinks.Settings() ? 'settings' : 'home'

  return (
    <div className="flex-none absolute bottom-6 left-1/2 -translate-x-1/2 w-[90%] z-50">
      <div className="bg-[#1C1F2E] rounded-[32px] p-2 flex justify-around items-center border-b-[6px] border-[#151722] shadow-2xl">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => navigate(tab.path)}
            className={`flex-1 flex flex-col items-center gap-1 p-3 rounded-[24px] transition-all duration-300 ${
              activeTab === tab.key ? 'bg-emerald-400/10 text-emerald-400' : 'text-gray-500'
            }`}
          >
            <Icon icon={tab.icon} className="w-6 h-6" />
            <span className="text-xs font-bold">{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
